export enum PdfCursorTools {
  SELECT = 0,
  HAND = 1,
  ZOOM = 2,
  PAGE_FLIP = -3 // #3140 added by ngx-extended-pdf-viewer (negative to avoid collision with upstream)
}
